import { render, staticRenderFns } from "./GenerateReturn.vue?vue&type=template&id=742a34ac&scoped=true&"
import script from "./GenerateReturn.vue?vue&type=script&lang=js&"
export * from "./GenerateReturn.vue?vue&type=script&lang=js&"
import style0 from "./GenerateReturn.vue?vue&type=style&index=0&id=742a34ac&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "742a34ac",
  null
  
)

export default component.exports